import { textFilter } from "react-bootstrap-table2-filter";
import {
  GetHeaderStyle,
  GetNormalStyle,
  GetThaiFormatDate,
  PostJson,
} from "../../core/Helper";
import { WebSearchHelperService } from "../../pages/tools/search-helper";
import { encode } from "js-base64";
import { getDecimalString } from "../../core/Helper2";

export class DocumentService {
  static async SaveDFRadPay(data, user) {
    let result = await PostJson("/api/paydf-rad/update", {
      data,
      user,
    });
    return result ?? null;
  }

  static async CancelDFRadPay(data, user) {
    let result = await PostJson("/api/paydf-rad/cancel", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetDFRadPay(data, user) {
    let result = await PostJson("/api/paydf-rad/getitem", {
      data,
      user,
    });
    return result ?? null;
  }

  static GetPaymentRadPayDetail = async (payDfDocuId, userDetail) => {
    if (payDfDocuId === undefined) return;
    let sql = "call rp_radi_df_payment_items(" + payDfDocuId + ",'')";
    let res = await WebSearchHelperService.GetBasicReport(
      {
        text: null,
        root: null,
        sql: encode(sql),
      },
      userDetail
    );
    return res;
  };

  static async SaveInvoice(data, user) {
    let result = await PostJson("/api/document-invoice/update", {
      data,
      user,
    });
    return result ?? null;
  }
  static async GetInvoice(data, user) {
    let result = await PostJson("/api/document-invoice/getItem", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetReceiptedInvoice(data, user) {
    let result = await PostJson("/api/receipted-invoices/getItem", {
      data,
      user,
    });
    return result ?? null;
  }

  static async SaveReceipt(data, user) {
    let result = await PostJson("/api/docu-receipt/update", {
      data,
      user,
    });
    return result ?? null;
  }

  static async GetReceipt(data, user) {
    let result = await PostJson("/api/docu-receipt/getItem", {
      data,
      user,
    });
    return result ?? null;
  }

  static async DeletePaymentItem(data, user) {
    let result = await PostJson("/api/docu-receipt/delete-payment-item", {
      data,
      user,
    });
    return result ?? null;
  }

  /** Billing Note */
  /** BILLING NOTE */

  static async SaveBillingNote(data, user) {
    let result = await PostJson("/api/billing-note/update", {
      data,
      user,
    });
    return result ?? null;
  }
  static async GetBillingNote(data, user) {
    let result = await PostJson("/api/billing-note/getItem", {
      data,
      user,
    });
    return result ?? null;
  }
}

export const SearchDFRadPay = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;
  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "paydf_docu_id";
  setSearchB({
    autoFirstPage: true,
    title: "ใบสำคัญจ่าย",
    size: "xl",
    show: true,
    fieldId: idFieldName,
    fieldName: "bankname",
    sql: {
      fields: [
        "a.paydf_docu_id",
        "docu_no",
        "docu_date",
        "concat(firstname, ' ', lastname) as fullname",
        "amount",
      ],
      tableName:
        "docu_payment_df_rad a inner join " +
        " ba_staff b on a.radi_staffid = b.staffid ",
      defaultCriteria: ` a.del_flag ='n' `,
      criteriaFields: ["a.docu_no", "b.firstname"],
      criteriaDateField: ["docu_date"],
      criteriaText: "",
      criteriaDateRanges: "",
      orderBy: ["a.docu_no"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        [item.fieldName]: result[idFieldName],
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "docu_no",
        text: "เลขที่เอกสาร",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "docu_date",
        text: "วันที่",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
        formatter: (cell, row) => GetThaiFormatDate(cell),
      },
      {
        dataField: "fullname",
        text: "รังสีแพทย์",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "amount",
        text: "ยอดจ่าย",
        sort: true,
        headerStyle: GetHeaderStyle("180px"),
        style: () => GetNormalStyle("right"),
        filter: textFilter({ placeholder: "..." }),
        formatter: (cell, row) => getDecimalString(cell, 2),
      },
    ],
  });
};

export const SearchBillNote = (props) => {
  const [setSearchB, data, setData, userInfo, item] = props;
  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "bill_note_id";
  setSearchB({
    autoFirstPage: true,
    title: "ใบวางบิล",
    size: "xl",
    show: true,
    fieldId: idFieldName,
    fieldName: "bankname",
    sql: {
      fields: [
        "a.bill_note_id",
        "docu_no",
        "docu_date",
        "cust_short",
        "net_total",
      ],
      tableName:
        "docu_billing_note a inner join " +
        " brch_customer cust on a.custid = cust.custid ",
      defaultCriteria: ` a.del_flag ='n' `,
      // and cust.brchid = ${userInfo.brchid}
      criteriaFields: ["a.docu_no", "cust_short"],
      criteriaDateField: ["docu_date"],
      criteriaText: "",
      criteriaDateRanges: "",
      orderBy: ["a.docu_no"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        [item.fieldName]: result[idFieldName],
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "docu_no",
        text: "เลขที่ใบวางบิล",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "docu_date",
        text: "วันที่",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
        formatter: (cell, row) => GetThaiFormatDate(cell),
      },
      {
        dataField: "cust_short",
        text: "หน่วยงานเรียกเก็บ",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "net_total",
        text: "ยอดวางบิล",
        sort: true,
        headerStyle: GetHeaderStyle("180px"),
        style: () => GetNormalStyle("right"),
        formatter: (cell, row) => getDecimalString(cell, 2),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};
